( function() {
	var $ = require('jquery');

	var lity = require('lity');

	// Ajax call for modal
	$('.companies').on('click', '.company__link',  function(event) {
		event.preventDefault();
		var post_id = $(this).data('id');

		var company_box = $(this).attr('href');
		// Show loader icon
		$(this).find('.icon-spin2').addClass('icon-show');
		$(this).find('.company__overlay').addClass('company__overlay--visible');

		$.ajax({
			url : getcompany.ajax_url,
			type : 'post',
			data : {
				action : 'wd_get_company',
				post_id : post_id
			},
			success : function( response ) {
				$('.company-info').html( response );
				$('.icon-spin2').removeClass('icon-show');
				$('.company__overlay').removeClass('company__overlay--visible');
				var instance = lity(company_box);

				// Close lity lightbox and clear content
				$('.company-info').on('click', '.company-info__close' , function() {
					instance.close();
				});
			}
		});

	});

})();
